module.exports = __webpack_public_path__ + "static/media/logo_one.5e05f022.png";